<template>
    <div class="navigation" id="energyNav">
        <div class="box">
            <el-menu
            :default-active="$store.state.energyIndex"
            class="el-menu-vertical-demo"
            :text-color="cssType==0?'#fff':'#555'"
            :active-text-color="cssType==0?'#fff':'#333'"
            :unique-opened="true"
            @select="select"
            >
                <el-menu-item index="/Energy/index" :class="{'isactive':$store.state.energyIndex=='/Energy/index'}">
                    <img :src="icon0" class="icon">
                    <span slot="title">监控中心</span>
                </el-menu-item>
                <el-menu-item index="/Energy/ElectricMonitor" :class="{'isactive':$store.state.energyIndex=='/Energy/ElectricMonitor'}">
                    <img :src="icon1" class="icon">
                    <span slot="title">电气监控</span>
                </el-menu-item>
                <el-submenu index="1">
                    <template slot="title">
                        <img :src="icon2" class="icon">
                        <span>统计报表</span>
                    </template>
                    <el-menu-item-group class="menu">
                        <el-menu-item index="/Energy/MeterReport" :class="{'isactive':$store.state.energyIndex=='/Energy/MeterReport'}">抄表记录</el-menu-item>
                        <el-menu-item index="/Energy/RatioReport" :class="{'isactive':$store.state.energyIndex=='/Energy/RatioReport'}">环比报表</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="2" class="left-0">
                    <template slot="title">
                        <img :src="icon2" class="icon">
                        <span>设置&nbsp;&nbsp;</span>
                    </template>
                    <el-menu-item-group class="menu">
                        <el-menu-item index="/Energy/EnergyConfig" :class="{'isactive':$store.state.energyIndex=='/Energy/EnergyConfig'}">系统参数</el-menu-item>
                        <el-menu-item index="/Energy/EnergyDataConfig" :class="{'isactive':$store.state.energyIndex=='/Energy/EnergyDataConfig'}">数据源</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </el-menu>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            icon0:require("@/assets/image/left/yibiao"+this.cssType+".png"),    //监控中心
            icon1:require("@/assets/image/left/diannao"+this.cssType+".png"),         //电气监控
            icon2:require("@/assets/image/left/journal"+this.cssType+".png"),     //统计报表
        }
    },
    // computed: {
    //     test(){
    //         return this.$store.state.activeIndex
    //     }
    // },
    methods: {
        select(key){
          // console.log(key)
          if(key){
            this.$store.state.energyIndex = key
            this.$router.push({path:key})
          }
        }
    },
    // watch: {
    //     index(val){
    //         if(val!=this.$store.state.activeIndex){
    //             this.$store.state.activeIndex = val
    //             console.log(val)
    //         }
    //     },
    //     test(val){
    //         if(val!=this.index){
    //             this.index = val
    //             console.log(this.index)
    //         }
    //     }
    // },
}
</script>
<style scoped>
    .el-menu{
        background: transparent !important;
    }
    .navigation{
        width:208px;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        background-color: #2f3a4e;
        padding-top: 24px;
        min-height: 820px;
        z-index: 0;
        overflow: auto;
    }
    .lists{
        width: 100%;
        line-height: 52px;
        position: relative;
    }
    .lists:hover{
        background-color: #575f70;
    }
    .lists-txt{
        color: #fff;
        font-size: 16px;
        font-weight: 400;
    }
    .icon{
        width: 20px;
        position: relative;
        /* top: 5px; */
        right: 5px;
    }
    .lab-box{
        width: 110px;
        margin: 0 auto;
        text-align: left;
    }
    .active:hover{
        background-color: #575f70;
    }
    .active2{
        background-color: #575f70;
    }
    .left-5{
        padding-left: 5px !important;
    }
    .el-menu-item.isactive{
        background-color: #575f70;
    }
    .el-menu-item.isactive:after{
        content: "";
        display: block;
        position: absolute;
        top:0;
        width: 8px;
        left: 0;
        height: 100%;
        background-color: #5087e4;
    }
    .el-submenu__title:hover{
        background-color: #575f70;
    }
    .el-menu-item:hover{
        background-color: #575f70 ;
    }
    .el-menu-item-group.menu{
        background: #2f3a4e;
    }
    .el-menu{
        border: 0 !important;
    }
</style>
<style>
    #energyNav .el-submenu .el-submenu__title:hover{
        background-color: #575f70;
    }
    #energyNav .left-0 .el-submenu__title{
      padding-left: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/PublicAssembly/EnergyNavigation.vue